'use strict';

wbApp.controller('CoursesCtrl', ['$scope', '$modal', '$window', '$translate', '$filter', 'semesterSvc',
    'courseSvc', 'securitySvc', 'tenantSettingSvc', 'courseTypeSvc', 'courseRegistrationSvc',
function ($scope, $modal, $window, $translate, $filter, semesterSvc, courseSvc, securitySvc, tenantSettingSvc, courseTypeSvc,
    courseRegistrationSvc) {

    $scope.isInAccountingBookRole = securitySvc.isInRole('AccountingBook');
    $scope.filteredCourses = [];
    $scope.rawCourses = [];
    $scope.courses = [];
    $scope.customFilter = { compensationGroupID: null };
    $scope.courseTypes = courseTypeSvc.getAllForLookup();
    
    function preFilter() {
        if (!$scope.rawCourses.$promise) {
            return;
        }

        $scope.rawCourses.$promise.then(function () {
            if (!$scope.customFilter.compensationGroupID) {
                $scope.courses.length = 0;
                $scope.courses.push.apply($scope.courses, $scope.rawCourses);
            } else {
                $scope.courses.length = 0;
                $scope.courses.push.apply($scope.courses,
                    _.filter($scope.rawCourses, function (o) {
                        return o.compensationGroupID == $scope.customFilter.compensationGroupID;
                    }));
            }

            $scope.filteredCourses = $scope.courses;
        });
    }

    $scope.$watch('customFilter.compensationGroupID', function (newValue, oldValue) {
        preFilter();
    }, true);

    function setSelectedCourse(course, refresh) {
        $scope.selectedCourse = course;

        if (!course && !!$scope.gridSettings.gridInstance) {
            $scope.gridSettings.gridInstance.clearSelection();
        }

        $scope.$broadcast('selectedCourseChanged', { course: course, refresh: !!refresh });
    }

    $scope.enableZoomIntegration = tenantSettingSvc.settings.enableZoomIntegration;

    semesterSvc.getDefaultAsync()
        .then(function (semester) {
            $scope.semesterID = semester.id;

            $scope.rawCourses = courseSvc.getAllAsync($scope.semesterID, true);
            // $scope.filteredCourses = $scope.rawCourses;
            preFilter();
            setSelectedCourse(null);
        });

    function refreshData() {
        if ($scope.semesterID) {
            $scope.rawCourses = courseSvc.getAllAsync($scope.semesterID, true);
            preFilter();
            //$scope.filteredCourses = $scope.rawCourses;
            setSelectedCourse(null);
        }
    }

    $scope.$on('refreshData', function (e, data) {
        refreshData();
    });

    $scope.$on('onCourseShouldRefresh', function (e, data) {
        courseSvc.refreshCourseRecord($scope.semesterID, data.course.courseID, $scope.courses, function () {
            if ($scope.selectedCourse.courseID === data.course.courseID) {
                setSelectedCourse(data.course, true);
                if ($scope.gridSettings.gridInstance) {
                    $scope.gridSettings.gridInstance.selectRows(data.course, false);
                }
            }
        });
    });

    $scope.getSemesterPercentFilled = function () {
        return ($scope.getSemesterFilled() / $scope.getSemesterCapacity()) * 100;
    }

    $scope.getSemesterFilled = function () {
        if (!!$scope.filteredCourses) {
            return _.reduce($scope.filteredCourses, function (total, n) {
                return total + n.filled;
            }, 0);
        }
        return 0;
    }

    $scope.getSemesterCapacity = function () {
        if (!!$scope.filteredCourses) {
            return _.reduce($scope.filteredCourses, function (total, n) {
                return total + n.capacity;
            }, 0);
        }
        return 100;
    }

    $scope.onFilterApplied = function (rows) {
        $scope.filteredCourses = rows;
    }

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            $scope.rawCourses = courseSvc.getAllAsync($scope.semesterID, true);
            preFilter();
        }
        setSelectedCourse(null);
    }

    $scope.gridSettings = {
        name: 'courses',
        keyExpr: 'courseID',
        columns: [
            { dataField: 'courseID', caption: $translate.instant('TXT_LBL_ID'), dataType: 'number', visible: false },
            { dataField: 'abbreviation', caption: $translate.instant("TXT_LBL_ABBREVIATION"), dataType: 'string', width: '130px' },
            {
                dataField: 'courseTypeID',
                caption: $translate.instant("TXT_LBL_COURSE_TYPE"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('courseType')(rowData.courseTypeID);
                },
                width: '110px'
            },
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string' },            
            { dataField: 'subjectName', caption: $translate.instant('TXT_LBL_SUBJECT'), dataType: 'string', sortOrder: 'asc' },
            {
                dataField: 'firstLesson',
                caption: $translate.instant('TXT_MENU_SCHEDULE'),
                dataType: 'date',
                format: { raw: "EEE HH:mm" },
                calculateSortValue: function (rowData) {
                    var mfirstLesson = moment(rowData.firstLesson);
                    return mfirstLesson.isValid()
                        ? mfirstLesson.day() * 10000 + mfirstLesson.hour() * 100 + mfirstLesson.minute()
                        : rowData.firstLesson;
                },
                width: '90px'
            },
            { dataField: 'teacher', caption: $translate.instant('TXT_LBL_EMPLOYEE'), dataType: 'string', width: '170px' },
            { dataField: 'filled', caption: $translate.instant('TXT_LBL_FILLED'), dataType: 'number', width: '80px' },
            { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'fixedPrice', caption: $translate.instant('TXT_LBL_FIXED_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'allowRegistration', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
            { dataField: 'isOnlineMeeting', caption: $translate.instant('TXT_LBL_ONLINE'), dataType: 'boolean', width: '60px', visible: $scope.enableZoomIntegration },
            { dataField: 'lessonLengthInMinutes', caption: $translate.instant('TXT_LBL_LESSON_LENGTH'), dataType: 'number', width: '120px', visible: false },
        ],
        onRowPrepared: function (e) {
            if (e.rowType === "data") {
                let data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.filled >= data.capacity) {
                    e.rowElement.addClass('text-muted');
                }
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_MENU_PRINT_INFO_CARD'),
            isVisible: function () { return securitySvc.isInRole('Course.InfoCard') && securitySvc.isInRole('Reports'); },
            callback: function (data) { onPrintInfoCard(data.courseID); }
        }, {
            text: $translate.instant('TXT_MENU_RESEND_COURSE_REGISTRATION_NOTIFICATION'),
            isVisible: function () { return securitySvc.isInRole('CourseRegistration'); },
            callback: function (data) { onResendCourseRegistrationNotification(data.courseID); }
        }, {
            text: $translate.instant('TXT_COPY'),
            isVisible: function () {
                return securitySvc.isInRole('Course.Copy') &&
                securitySvc.isInRole('CourseRegistration.Insert') &&
                securitySvc.isInRole('CourseSchedule.Insert') &&
                securitySvc.isInRole('Course.Insert');
            },
            callback: function (data) { onCourseCopy(data.courseID); }
        }]
    }

    function onResendCourseRegistrationNotification(courseID) {
        var courseRegistrations = courseRegistrationSvc.getAllForCourse(courseID);
        courseRegistrations.$promise.then(function (data) {
            _.forEach(data, function (courseRegistration) {
                courseRegistrationSvc.sendRegistrationNotification(courseRegistration.courseRegistrationID);
            });
        });
    }


    function onPrintInfoCard(courseID) {
        $window.open('/Admin/Report/InfoCard?CourseID=' + courseID,
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    function onCourseCopy(courseID) {
        courseSvc.getByCourseID(courseID).$promise.then(function (course) {
            detailCopyDialogPromise.$promise.then(function () {
                detailCopyDialogPromise.$scope.model = angular.copy(course);
                detailCopyDialogPromise.$scope.onCourseCopySave = function () {
                    refreshData();
                };
                detailCopyDialogPromise.show();
            });
        });
    }

    $scope.selectedCourse = {};

    $scope.onRowSelected = function (data) {
        $scope.selectedCourse = data;
        setSelectedCourse($scope.selectedCourse);
    }

    $scope.onRowEdit = function (data) {
        courseSvc.getByCourseID(data.courseID).$promise.then(function (course) {
            detailDialogPromise.$promise.then(function () {
                detailDialogPromise.$scope.collection = $scope.courses;
                detailDialogPromise.$scope.model = angular.copy(course);
                detailDialogPromise.$scope.onCourseSave = function (model) {
                    setSelectedCourse(model, true);
                };
                detailDialogPromise.show();
            });
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.courses;
            detailDialogPromise.$scope.model = courseSvc.createNew($scope.semesterID, false);
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        courseSvc.remove(data, $scope.courses, function () {
            $scope.selectedCourse = null;
            setSelectedCourse(null);
        });
    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "courses/courses/courses-detail-tabs/detail.html"
    }, {
        title: 'TXT_LBL_STUDENTS',
        template: 'courses/courses/courses-detail-tabs/students.html'
    }, {
        title: 'TXT_MENU_SCHEDULE',
        template: 'courses/courses/courses-detail-tabs/schedule.html'
    }, {
        title: 'TXT_LBL_ATTENDANCE',
        template: 'courses/courses/courses-detail-tabs/attendance.html'
    }];

    if (securitySvc.isInRole('Leads'))
    {
        $scope.tabs.push({
            title: 'TXT_ENABLE_FULL_COURSE_INTEREST',
            template: 'courses/courses/courses-detail-tabs/leads.html'
        });
    }

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

    var detailDialogPromise = $modal({
        templateUrl: 'courses/courses/detail.html',
        show: false,
        scope: $scope.$new()
    });


    var detailCopyDialogPromise = $modal({
        templateUrl: 'courses/courses/copy-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
